export const authRequired = {
  name: 'authRequired',
  path: '/auth-required',
  component: () => import('@/views/authRequired'),
  meta: {
    layout: 'empty',
    guestOnly: true
  }
}
